import { getWorkspaceSubscriptionProblem } from "lib/actions/getWorkspaceBillingProblem";
import { useCurrentProject } from "lib/hooks/useProject";
import { useWorkspaceSubscription } from "lib/hooks/useWorkspaceSubscription";
import Breadcrumbs from "components/elements/Breadcrumbs/Breadcrumbs";
import AccountDropdown from "./AccountDropdown";
import ProjectDropdown from "./ProjectDropdown";
import IngressJobsButton from "./IngressJobsDropdown/IngressJobsButton";
import IngressJobsButtonV2 from "./IngressJobDropdownV2/IngressJobsButtonV2";
import NotificationsButton from "../Notifications/NotificationsButton";
import SubscriptionProblemBanner from "./SubscriptionProblemBanner";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useState } from "react";
import { useMeasureRef } from "lib/hooks/useMeasureRef";

// Below this header width (about an 880 px window) the project dropdown shows
// just the project icon, so the breadcrumb keeps room for the current page.
const compactProjectHeaderWidth = 760;

export default function Header() {
  const { isProjectOpen, project } = useCurrentProject();
  const { subscriptionStatus } = useWorkspaceSubscription(
    project?.workspace.id,
  );
  const { featureIngressModal: hasIngressModal } = useFlags();

  const subscriptionProblem =
    getWorkspaceSubscriptionProblem(subscriptionStatus);

  const isShowingLicenseProblem =
    project?.workspace?.canManage && !!subscriptionProblem;

  const [headerWidth, setHeaderWidth] = useState(0);
  const setHeaderMeasureRef = useMeasureRef((bb) => setHeaderWidth(bb.width));
  const isProjectCompact =
    headerWidth > 0 && headerWidth < compactProjectHeaderWidth;

  return (
    <div
      ref={setHeaderMeasureRef}
      className="mb-4 flex items-center justify-between gap-4 rounded-lg bg-white p-2 shadow-1"
    >
      <div className="flex w-0 min-w-0 flex-1 items-center justify-start">
        <div className="flex min-w-0 flex-1 flex-row items-stretch justify-start pl-2">
          <Breadcrumbs />
        </div>
      </div>

      <div className="mr-2 flex shrink-0 items-center justify-end gap-1 whitespace-nowrap">
        {isShowingLicenseProblem && (
          <SubscriptionProblemBanner
            problem={subscriptionProblem}
            workspaceId={project?.workspace.id}
          />
        )}
        {isProjectOpen &&
          (hasIngressModal ? <IngressJobsButtonV2 /> : <IngressJobsButton />)}
        <NotificationsButton />
        <ProjectDropdown isCompact={isProjectCompact} />
        <AccountDropdown />
      </div>
    </div>
  );
}
